export const defaultPresets = {
    cartridge: {
        id: "cartridge",
        name: "Cartridge",
        icon: "/whitelabel/cartridge/icon.svg",
        cover: {
            light: "/whitelabel/cartridge/cover-light.png",
            dark: "/whitelabel/cartridge/cover-dark.png",
        },
    },
    "force-prime": {
        id: "force-prime",
        name: "Force Prime",
        icon: "/whitelabel/force-prime/icon.png",
        cover: "/whitelabel/force-prime/cover.png",
        colors: {
            primary: "#E1CC89",
        },
    },
    paved: {
        id: "paved",
        name: "Paved",
        icon: "/whitelabel/paved/icon.svg",
        cover: "/whitelabel/paved/cover.png",
        colors: {
            primary: "#B0CAF8",
        },
    },
    pistols: {
        id: "pistols",
        name: "Pistols at Ten Blocks",
        icon: "/whitelabel/pistols/icon.png",
        cover: "/whitelabel/pistols/cover.png",
        colors: {
            primary: "#EF9758",
        },
    },
    pixelaw: {
        id: "pixelaw",
        name: "Pixelaw",
        icon: "/whitelabel/pixelaw/icon.svg",
        cover: "/whitelabel/pixelaw/cover.png",
        colors: {
            primary: "#7C00B1",
            primaryForeground: "white",
        },
    },
    "dope-wars": {
        id: "dope-wars",
        name: "Dope Wars",
        icon: "/whitelabel/dope-wars/icon.png",
        cover: "/whitelabel/dope-wars/cover.png",
        colors: {
            primary: "#11ED83",
        },
    },
    zkastle: {
        id: "zkastle",
        name: "zKastle",
        icon: "/whitelabel/zkastle/icon.svg",
        cover: "/whitelabel/zkastle/cover.png",
        colors: {
            primary: "#E50D2C",
        },
    },
    "loot-survivor": {
        id: "loot-survivor",
        name: "Loot Survivor",
        icon: "/whitelabel/loot-survivor/icon.png",
        cover: "/whitelabel/loot-survivor/cover.png",
        colors: {
            primary: "#33FF33",
        },
    },
    "tale-weaver": {
        id: "tale-weaver",
        name: "Tale Weaver",
        icon: "/whitelabel/tale-weaver/icon.png",
        cover: "/whitelabel/tale-weaver/cover.png",
        colors: {
            primary: "#fce377",
        },
    },
    "realm-of-ra": {
        id: "realm-of-ra",
        name: "Realm of Ra",
        icon: "/whitelabel/realm-of-ra/icon.png",
        cover: "/whitelabel/realm-of-ra/cover.png",
        colors: {
            primary: "#de9534",
        },
    },
    "jokers-of-neon": {
        id: "jokers-of-neon",
        name: "Jokers of Neon",
        icon: "/whitelabel/jokers-of-neon/icon.png",
        cover: "/whitelabel/jokers-of-neon/cover.png",
        colors: {
            primary: "#A144B2",
        },
    },
    flippyflop: {
        id: "flippyflop",
        name: "FlippyFlop",
        icon: "/whitelabel/flippyflop/icon.png",
        cover: "/whitelabel/flippyflop/cover.png",
        colors: {
            primary: "#F38332",
        },
    },
};
//# sourceMappingURL=presets.js.map